import Modal from 'react-modal';
import { useQuery } from '@apollo/client';
import Button from '../../../../GlobalComponents/Button';
import ModalHeader from '../../../../GlobalComponents/Modal/ModalHeader';
import Checkbox from '../../../../GlobalComponents/Checkbox';
import { useTranslation } from 'react-i18next';
import Error from '../../../../GlobalComponents/Error';
import { GetApolloErrorText } from '../../../../GlobalFunctions/helper';
import Loading from '../../../../GlobalComponents/Loading';
import { GET_TICKLABELS } from '../../Queries/tickLabels';
import { UseAuth } from '../../../Auth/Library/UseAuth';

const ChooseTickLabels = ({
    formData,
    SetShowAddTickLabels,
    FillFormSelectedItemsWithObj
}) => {

    const {t} = useTranslation();
    const {user} = UseAuth();

    var lang = user ? user.lang : "";

    const {data,loading,error} = useQuery(GET_TICKLABELS,{
        variables:{
            lang: lang,
            limit:1000000,
            offset:0
        },
        fetchPolicy:"network-only",
        skip:(lang == "" ? true : false)
    })

    return(
        <Modal
            isOpen={true}
            onRequestClose={() => SetShowAddTickLabels(false)}
            overlayClassName={"modal-overlay"}
            className={"modal-content"}
        >
            <ModalHeader 
                title = {t("ChooseTickLabels")}
                OnClose ={() => SetShowAddTickLabels(false)}
            />

            <div className="modal-body">

                {error ?
                    <Error text={GetApolloErrorText(error)} />
                :
                    (loading ?
                        <Loading />
                    :
                        <>
                            {data.AllTickLabels && data.AllTickLabels.length > 0 ?
                                
                                <div className='row'>

                                    {data.AllTickLabels.map((item) => {

                                        var check = false;
                                        for(let val of formData.selectedTickLabels)
                                        {
                                            if(val.tickLabelID == item.tickLabelID)
                                                check = true;
                                        }

                                        return(
                                            <div key={item.tickLabelID} className="col-20">
                                                <div className="form-group">
                                                    <Checkbox 
                                                        name = "tickLabels"
                                                        id = {"l-" + item.tickLabelID}
                                                        checked = {check}
                                                        OnChange={() => FillFormSelectedItemsWithObj("selectedTickLabels","tickLabelID",{
                                                            name:item.name,
                                                            tickLabelID:item.tickLabelID,
                                                            useDates:0,
                                                            dateFrom:"",
                                                            dateTo:""
                                                        })}
                                                        text = {item.name}
                                                    /> 
                                                </div>
                                            </div>
                                        )
                                    })}
                                    
                                </div> 
                            :null}
                        </>
                    )
                }

            </div>
            <div className="modal-footer">
                <Button
                    className={"btn-primary w-100"}
                    OnClick={() => SetShowAddTickLabels(false)}
                >
                    {t("Choose")}
                </Button>
            </div>

        </Modal>
    )

}

export default ChooseTickLabels;